// extracted by mini-css-extract-plugin
export default {"side-container":"index-module__side-container--4vJjm","sticky-wrapper":"index-module__sticky-wrapper--GawCi","side-container--infos":"index-module__side-container--infos--XV7vM"};